export default function Instructions() {
  return (
    <>
      <div className="instructions">
        <div>WASD to move your degen around •</div>
      </div>
    </>
  );
}
